import { StyleSheet } from 'react-native';

import { LI } from '@expo/html-elements';
import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsNutritionEntriesItem = (props: Props) => {
  const { title, value } = props;

  return (
    <LI style={styles.container}>
      <BodyText sizeMatch={['16']} style={styles.text}>
        {title}
      </BodyText>

      <BodyText sizeMatch={['16']} style={styles.text}>
        {value}
      </BodyText>
    </LI>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: theme.spacing['2'],
    justifyContent: 'space-between',
  },
  text: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  title: string;
  value: string | number;
};
